import type { Object3D, Object3DEventMap, OrbitControls, PerspectiveCamera, Scene } from '@anov/3d-core'
import { BufferGeometry, Mesh, MeshBVH, Quaternion, Vector3, acceleratedRaycast } from '@anov/3d-core'
import { SPEED } from '../config/constants'
import type BasicCharacterControllerInput from '../action/input'
import type Character_animation from './animation'

Mesh.prototype.raycast = acceleratedRaycast

interface PropsType {
  scene: Scene
  character: Object3D
  characterRotateBox: Object3D
  input: BasicCharacterControllerInput
  animation: Character_animation
  camera: PerspectiveCamera
}

export default class Character_control {
  input: BasicCharacterControllerInput
  character: Object3D
  control: OrbitControls | any
  currentPosition: Vector3
  camera: PerspectiveCamera
  isRoll: boolean | any
  isMove = false
  animation: Character_animation
  characterRotateBox: Object3D
  characterRotateAngle = {
    allowSet: true,
    angle: 1,
  }

  scene: Scene
  forwardVector: Vector3

  constructor({
    scene,
    character,
    input,
    animation,
    characterRotateBox,
    camera,
  }: PropsType) {
    this.input = input
    this.character = character
    this.characterRotateBox = characterRotateBox
    this.animation = animation
    this.scene = scene
    this.camera = camera

    this.currentPosition = new Vector3()
    this.forwardVector = new Vector3()
    this.character.getWorldDirection(this.forwardVector)
    this.forwardVector.y = 0
    this.forwardVector.normalize()
  }

  updateNewPosition(deltaT: number) {
    const { forward, backward, left, right } = this.input.keys

    // 获取当前角色的前向向量
    const forwardVector = new Vector3()
    this.characterRotateBox.getWorldDirection(forwardVector)
    forwardVector.y = 0
    forwardVector.normalize()

    const vectorUp = new Vector3(0, 1, 0)
    const vectorRight = new Vector3().crossVectors(vectorUp, forwardVector).normalize()

    const moveDirection = new Vector3()

    if (forward)
      moveDirection.add(forwardVector)
    if (backward)
      moveDirection.sub(forwardVector)
    if (left)
      moveDirection.add(vectorRight)
    if (right)
      moveDirection.sub(vectorRight)

    // 计算最终移动向量
    const moveVector = moveDirection.normalize().multiplyScalar(SPEED * deltaT)

    // 更新角色的位置
    if (!this.animation.preventAction)
      this.character.position.add(moveVector)
  }

  update(deltaT: number) {
    this.updateNewPosition(deltaT)
  }
}
